import { createFileRoute } from "@tanstack/react-router";
import { RegistrationContainer } from "../app/views/registrationContainer";

export const Route = createFileRoute("/registration")({
  component: RegistrationContainer,
});
